define('environments/global',{
  i18n: {
    auth401title: 'Session expired (Sesión inválida)',
    auth401message: 'Your session has expired. Please log in again.\n(Tu sesión ha expirado. Por favor, vuelve a introducir tus datos de acceso)',
    auth403title: 'Forbidden (Error de acceso)',
    auth403message: 'You are not authorized to access this resource.\n(No dispones de permisos para acceder a este módulo o aplicación. Serás redirigido a la sección de mi cuenta de MDirector.)',
    auth500title: 'Internal Server Error (Error interno del servidor)',
    auth500message: 'Something went wrong on our side. Please try again later.\n(Ha ocurrido un error por nuestra parte. Por favor, inténtalo de nuevo más tarde.)',
  }
});

